import React, { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import { MinimalSelect2 } from "../../components/MinimalSelect";

import { UserContext } from "../../context/UserContext";
import { SemesterContext } from "../../context/SemesterContext";

interface Props {
  onChange: any;
  option: any;
}
const CompetencyVersionSelect = (props: Props) => {
  const { onChange, option } = props;
  const screenClass = useScreenClass();
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const { selectedVersion } = useContext(UserContext);
  const semesterContext = useContext(SemesterContext);

  const selectedVersionObject =
    option?.find((v: any) => v.value === selectedVersion) || {};

  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  useEffect(() => {
    onChange({ label: "All Versions", value: 0 });
  }, [semesterContext.selectedSemester]);

  return (
    <>
      <MinimalSelect2
        isDisabled={isDisabled}
        setClass={isMobile ? "rs-container" : ""}
        placeholder="Select Version"
        options={[...option, { label: "All Version", value: 0 }]}
        value={
          selectedVersion === 0
            ? { label: "All Versions", value: 0 }
            : selectedVersionObject
        }
        onChange={(data: any) => {
          onChange(data);
        }}
      ></MinimalSelect2>
    </>
  );
};

export default CompetencyVersionSelect;
